/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeV2AnchorLinkMenuData } from './moe-v2-anchor-link-menu.data';
import { IMoeV2AnchorLinkMenuProps } from './moe-v2-anchor-link-menu.props.autogenerated';

export interface IMoeV2AnchorLinkMenuViewProps extends IMoeV2AnchorLinkMenuProps<IMoeV2AnchorLinkMenuData> {}

/**
 *
 * MoeV2AnchorLinkMenu component
 * @extends {React.PureComponent<IMoeV2AnchorLinkMenuProps<IMoeV2AnchorLinkMenuData>>}
 */
class MoeV2AnchorLinkMenu extends React.PureComponent<IMoeV2AnchorLinkMenuProps<IMoeV2AnchorLinkMenuData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2AnchorLinkMenu;
